export default __webpack_public_path__ + "static/media/proposal_icon.08d94318.svg";